import fs from 'node:fs'
import path from 'node:path'
import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'
import { findUpwards } from '@cli-utils/files.js'
import { isSupportedPnpmPackageManager } from '@next-adapter/package-json/is-supported-pnpm-package-manager.js'

export function hasSupportedAncestorPnpmPackageManager(cwd: string): boolean {
  const start = path.dirname(path.resolve(cwd))

  return (
    findUpwards(start, (dir) => {
      const packageJsonPath = path.join(dir, 'package.json')
      if (!fs.existsSync(packageJsonPath)) return undefined

      try {
        const packageJson = JSON.parse(
          fs.readFileSync(packageJsonPath, 'utf-8')
        ) as ProjectPackageJson
        if (packageJson.packageManager) {
          return isSupportedPnpmPackageManager(packageJson.packageManager)
        }
      } catch {}

      return undefined
    }) ?? false
  )
}
